// Unpublished Work © 2022-2023 Deere & Company.

import t from 'tcomb';
import {DbsCustomer} from './dbs-customer';
import {DbsLabels} from './dbs-labels';
import {PageStatus} from '../page-status';
import {DbsCustomerError} from './dbs-customer-error';

export const DbsCustomerProfile = t.struct({
    customer: DbsCustomer,
    dbsLabels: DbsLabels,
    pageStatus: PageStatus,
    showDBSCustomerDetailsModal: t.Boolean,
    dbsCustomerError: DbsCustomerError
}, {
    defaultProps: {
        customer: new DbsCustomer({}),
        dbsLabels: new DbsLabels({}),
        pageStatus: PageStatus.meta.map.COMPLETE,
        showDBSCustomerDetailsModal: false,
        dbsCustomerError: new DbsCustomerError({})
    },
    name: 'DbsCustomerProfile',
    strict: true
});

DbsCustomerProfile.prototype.getKeyValuePair = function (objectKey, key) {
    if (objectKey !== '') {
        return {
            label: this.dbsLabels[objectKey][key],
            value: this.customer[objectKey][key]
        };
    }
    return {
        label: this.dbsLabels[key],
        value: this.customer[key]
    };
};
